import { render, staticRenderFns } from "./header.vue?vue&type=template&id=579e5bbb&scoped=true&"
import script from "./header.vue?vue&type=script&lang=js&"
export * from "./header.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./header.vue?vue&type=style&index=0&id=579e5bbb&scoped=true&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "579e5bbb",
  "d5f5dcba"
  
)

export default component.exports